
import { Component, Input, Output, EventEmitter, forwardRef } from '@angular/core';
import { FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { RadioButtonModule } from 'primeng/radiobutton';

@Component({
  selector: 'app-radio-button',
  templateUrl: './radiobutton.component.html',
  standalone: true,
  styleUrls: ['./radiobutton.component.scss'],
  imports: [FormsModule, RadioButtonModule],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => RadioButtonComponent),
    multi: true
  }]
})

export class RadioButtonComponent {
  @Input() name: string = '';
  @Input() options: string[] = [];
  @Input() ngModel: string = '';
  @Output() ngModelChange = new EventEmitter<string>();
  @Output() onClick = new EventEmitter<string>();
  @Input() isDisabled: boolean = false;
  @Input() isRequired: boolean = false;
  
  handleClick(value: string) {
    this.ngModel = value;
    this.ngModelChange.emit(value);
    this.onClick.emit(value);
  }
  
  onChange = (_: any) => {};
  onTouched = () => {};

  writeValue(value: any): void {
    this.ngModel = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
}
  